module.exports = __webpack_public_path__ + "assets/img/mail.41bddeaa.webp";